import React from "react";
import { mapSpeakerVersionToDataTable as mapData } from "./Helper";
import ReusableDataTable from "src/components/table/ReusableDataTable";
import GetReleaseSpeakerVersionColumns from "./ColumnDefinition/ReleaseSpeakerVersionColumn/GetReleaseSpeakerVersionColumns";

const ReleaseSpeakerVersionTable = ({
  data,
  handleOpenPopup,
  handleChangeModeRelease,
  status,
}) => {
  const columns = GetReleaseSpeakerVersionColumns({
    handleOpenPopup,
    handleChangeModeRelease,
    status,
  });

  return (
    <ReusableDataTable columns={columns} data={mapData(data)} maxHeight={500} />
  );
};

export default ReleaseSpeakerVersionTable;
